(function () {
  'use strict';

  var MAX_FILES = 5;
  var MAX_BYTES_EACH = 35 * 1024 * 1024;
  var ALLOWED = ('png jpg jpeg gif bmp tif tiff webp heic heif avif ' +
    'pdf ai eps svg psd indd cdr ' +
    'emb dst pes exp jef vp3 ' +
    'doc docx xls xlsx csv txt ' +
    'otf ttf zip mp4 mov m4v').split(' ');

  function extOf(n) {
    var i = String(n || '').lastIndexOf('.');
    return i >= 0 ? String(n).slice(i + 1).toLowerCase() : '';
  }
  function mb(b) { return (b / (1024 * 1024)).toFixed(1); }

  // ---- injected intake fields -------------------------------------------
  var SERVICE_BLOCKS = {
    'Vehicle Wraps & Graphics': [
      ['wrap_count', 'How many vehicles?', 'text', null, 'col-6', 'e.g. 2'],
      ['wrap_vehicle', 'Year / make / model', 'text', null, 'col-6', 'e.g. 2021 Ford Transit 250'],
      ['wrap_coverage', 'Coverage', 'select',
        ['Full wrap', 'Partial wrap', 'Lettering & decals only', 'Not sure yet'], 'col-6']
    ],
    'Detailing Services': [
      ['detail_vehicle', 'Year / make / model', 'text', null, 'col-6', 'e.g. 2019 F-150'],
      ['detail_level', 'Service', 'select',
        ['Interior', 'Exterior', 'Interior + exterior', 'Paint correction', 'Ceramic coating', 'Not sure yet'], 'col-6']
    ],
    'Custom Apparel': [
      ['apparel_garment', 'Garment type', 'text', null, 'col-6', 'e.g. hoodies, tees, hats'],
      ['apparel_locations', 'Print locations', 'select',
        ['1 location', '2 locations', '3 or more', 'Not sure yet'], 'col-6'],
      ['apparel_sizes', 'Size breakdown (if known)', 'text', null, 'col-12', 'e.g. 10 M, 15 L, 5 XL']
    ],
    'Signs & Banners': [
      ['signs_size', 'Size / dimensions', 'text', null, 'col-6', 'e.g. 3ft x 8ft'],
      ['signs_env', 'Indoor or outdoor?', 'select', ['Indoor', 'Outdoor', 'Both'], 'col-6']
    ],
    'Print & Paper Products': [
      ['print_item', 'What are we printing?', 'text', null, 'col-6', 'e.g. business cards, booklets'],
      ['print_size', 'Finished size', 'text', null, 'col-6', 'e.g. 3.5 x 2 in']
    ],
    'Promo Items': [
      ['promo_item', 'What item(s)?', 'text', null, 'col-12', 'e.g. koozies, pens, keychains']
    ],
    'Logo / Design Help': [
      ['design_have', 'What do you have now?', 'select',
        ['Nothing yet', 'A rough idea or sketch', 'An old logo to clean up', 'Full brand files'], 'col-12']
    ]
  };

  function mkField(name, labelText, kind, options, colClass, placeholder) {
    var wrap = document.createElement('div');
    wrap.className = 'vgc-field ' + (colClass || 'col-6');
    var id = 'vgc-x-' + name;

    var lab = document.createElement('label');
    lab.setAttribute('for', id);
    lab.textContent = labelText;
    wrap.appendChild(lab);

    var ctrl;
    if (kind === 'select') {
      ctrl = document.createElement('select');
      ctrl.className = 'vgc-select';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Select one';
      ctrl.appendChild(ph);
      (options || []).forEach(function (o) {
        var op = document.createElement('option');
        op.value = o;
        op.textContent = o;
        ctrl.appendChild(op);
      });
    } else {
      ctrl = document.createElement('input');
      ctrl.className = 'vgc-input';
      ctrl.type = 'text';
      if (placeholder) ctrl.placeholder = placeholder;
    }
    ctrl.id = id;
    ctrl.name = name;
    wrap.appendChild(ctrl);
    return wrap;
  }

  function init() {
    var form = document.querySelector('form.vgc-form');
    if (!form || form.getAttribute('data-vgc-v2')) return;
    form.setAttribute('data-vgc-v2', '1');

    var endpoint = form.getAttribute('action');
    if (!endpoint) return;

    var btn = form.querySelector('.vgc-btn-primary');
    var statusEl = form.querySelector('.vgc-status');
    var listEl = form.querySelector('.vgc-file-list');
    var oldInput = form.querySelector('input[type="file"]');
    if (!btn || !oldInput) return;

    function say(msg) { if (statusEl) statusEl.textContent = msg || ''; }

    var input = oldInput.cloneNode(true);
    input.accept = '.' + ALLOWED.join(',.');
    oldInput.parentNode.replaceChild(input, oldInput);

    var svc = form.querySelectorAll('input[name="service"]');
    if (svc.length) {
      Array.prototype.forEach.call(svc, function (i) {
        i.type = 'checkbox';
        i.removeAttribute('required');
        var chip = i.parentNode;
        if (chip && chip.classList) chip.classList.add('vgc-multi');
      });
      var g = form.querySelector('.vgc-chip-grid');
      var s = g ? g.parentNode : null;
      var t = s ? s.querySelector('.vgc-section-title') : null;
      if (t && !t.querySelector('.vgc-multi-hint')) {
        var hint = document.createElement('span');
        hint.className = 'vgc-multi-hint';
        hint.textContent = 'Select all that apply';
        t.appendChild(hint);
      }
    }

  // ---- autocomplete: real wins on mobile --------------------------------
  [['name','name'],['company','organization'],['email','email'],['phone','tel']]
    .forEach(function (p) {
      var el = form.querySelector('[name="' + p[0] + '"]');
      if (el) el.setAttribute('autocomplete', p[1]);
    });

  // ---- email typo catcher ----------------------------------------------
  // A mistyped domain means the lead is unreachable and you never find out.
  var COMMON_DOMAINS = ['gmail.com','yahoo.com','hotmail.com','outlook.com','aol.com',
    'icloud.com','comcast.net','verizon.net','msn.com','live.com','me.com','att.net'];

  function editDistance(a, b) {
    var m = [], i, j;
    for (i = 0; i <= b.length; i++) m[i] = [i];
    for (j = 0; j <= a.length; j++) m[0][j] = j;
    for (i = 1; i <= b.length; i++) {
      for (j = 1; j <= a.length; j++) {
        m[i][j] = b.charAt(i-1) === a.charAt(j-1)
          ? m[i-1][j-1]
          : Math.min(m[i-1][j-1] + 1, m[i][j-1] + 1, m[i-1][j] + 1);
      }
    }
    return m[b.length][a.length];
  }

  function suggestDomain(domain) {
    if (!domain || COMMON_DOMAINS.indexOf(domain) !== -1) return null;
    for (var i = 0; i < COMMON_DOMAINS.length; i++) {
      var d = COMMON_DOMAINS[i];
      if (editDistance(domain, d) <= 2 && Math.abs(domain.length - d.length) <= 2) return d;
    }
    return null;
  }

  var emailInput = form.querySelector('[name="email"]');
  if (emailInput) {
    var tip = document.createElement('div');
    tip.className = 'vgc-email-tip';
    tip.hidden = true;
    var emailWrap = emailInput.closest('.vgc-field');
    if (emailWrap) emailWrap.appendChild(tip);

    emailInput.addEventListener('blur', function () {
      var val = emailInput.value.trim();
      var at = val.lastIndexOf('@');
      if (at < 1) { tip.hidden = true; return; }
      var domain = val.slice(at + 1).toLowerCase();
      var better = suggestDomain(domain);
      if (!better) { tip.hidden = true; return; }
      var fixed = val.slice(0, at + 1) + better;
      tip.innerHTML = '';
      tip.appendChild(document.createTextNode('Did you mean '));
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'vgc-email-fix';
      a.textContent = fixed;
      a.addEventListener('click', function () {
        emailInput.value = fixed;
        tip.hidden = true;
        emailInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
      tip.appendChild(a);
      tip.appendChild(document.createTextNode('?'));
      tip.hidden = false;
    });
    emailInput.addEventListener('input', function () { tip.hidden = true; });
  }

  // ---- staff mode -------------------------------------------------------
  var staffMode = false;
  try { staffMode = localStorage.getItem('vgcStaff') === '1'; } catch (e) { staffMode = false; }

  function setStaff(on) {
    try {
      if (on) localStorage.setItem('vgcStaff', '1');
      else localStorage.removeItem('vgcStaff');
    } catch (e) {}
    location.reload();
  }

  // Hidden activation: five quick clicks on the "01" step badge toggles staff
  // mode. Deliberately not a URL flag - a link can be shared or bookmarked by
  // a customer, a click pattern cannot. The badge is an in-flow element, so
  // this adds no invisible overlay that could swallow taps on mobile.
  var hotspot = form.querySelector('.vgc-section-number');
  if (hotspot) {
    var taps = 0, tapTimer = null;
    hotspot.style.cursor = 'default';
    hotspot.addEventListener('click', function () {
      taps++;
      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () { taps = 0; }, 3000);
      if (taps < 5) return;
      taps = 0;
      setStaff(!staffMode);
    });
  }

  function hidden(name, value) {
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = name; h.value = value;
    form.appendChild(h);
    return h;
  }
  var staffFlag = hidden('staff_entry', staffMode ? '1' : '');
  var returningFlag = hidden('returning_customer', '');

  // ---- section 01: contact method + returning customer -------------------
  var phoneField = form.querySelector('[name="phone"]');
  var infoGrid = phoneField ? phoneField.closest('.vgc-grid') : null;
  if (infoGrid) {
    infoGrid.appendChild(mkField('contact_method', 'Best way to reach you', 'select',
      ['Email', 'Phone call', 'Text message'], 'col-6'));

    var retWrap = document.createElement('div');
    retWrap.className = 'vgc-field col-12';
    var retLab = document.createElement('label');
    retLab.className = 'vgc-check vgc-returning';
    var retBox = document.createElement('input');
    retBox.type = 'checkbox';
    var retTxt = document.createElement('span');
    retTxt.textContent = 'I am a returning customer - you already have my details on file';
    retLab.appendChild(retBox); retLab.appendChild(retTxt);
    retWrap.appendChild(retLab);
    infoGrid.appendChild(retWrap);

    retBox.addEventListener('change', function () {
      returningFlag.value = retBox.checked ? '1' : '';
      var hb = form.querySelector('[name="heard_about"]');
      var hbWrap = hb ? hb.closest('.vgc-field') : null;
      if (hbWrap) hbWrap.hidden = retBox.checked;
      if (retBox.checked && hb) hb.value = '';
    });
  }

  // ---- conditional per-service blocks ------------------------------------
  var chipGrid = form.querySelector('.vgc-chip-grid');
  var blockHost = document.createElement('div');
  blockHost.className = 'vgc-grid vgc-specifics';
  blockHost.hidden = true;
  if (chipGrid && chipGrid.parentNode) {
    chipGrid.parentNode.appendChild(blockHost);
  }

  function renderBlocks() {
    var picked = Array.prototype.filter.call(
      form.querySelectorAll('input[name="service"]'), function (i) { return i.checked; }
    ).map(function (i) { return i.value; });

    // keep whatever the visitor already typed
    var keep = {};
    blockHost.querySelectorAll('[name]').forEach(function (el) { keep[el.name] = el.value; });

    blockHost.innerHTML = '';
    picked.forEach(function (svcName) {
      var defs = SERVICE_BLOCKS[svcName];
      if (!defs) return;
      var head = document.createElement('div');
      head.className = 'vgc-specifics-head col-12';
      head.textContent = svcName;
      blockHost.appendChild(head);
      defs.forEach(function (d) {
        var f = mkField(d[0], d[1], d[2], d[3], d[4], d[5]);
        blockHost.appendChild(f);
        var ctrl = f.querySelector('[name]');
        if (ctrl && keep[ctrl.name]) ctrl.value = keep[ctrl.name];
      });
    });
    blockHost.hidden = picked.length === 0;
  }

  Array.prototype.forEach.call(form.querySelectorAll('input[name="service"]'), function (i) {
    i.addEventListener('change', renderBlocks);
  });

  // ---- section 03: quantity, budget, artwork, attribution -----------------
  var detailsField = form.querySelector('[name="project_details"]');
  var detailsWrap = detailsField ? detailsField.closest('.vgc-field') : null;
  var detailsGrid = detailsWrap ? detailsWrap.parentNode : null;
  if (detailsGrid && detailsWrap) {
    // These four are genuinely optional. On a phone the form is long, so they
    // start collapsed there and open on desktop - nobody is blocked by them.
    var more = document.createElement('div');
    more.className = 'vgc-more col-12';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'vgc-more-toggle';

    var moreInner = document.createElement('div');
    moreInner.className = 'vgc-grid vgc-more-inner';

    [
      mkField('quantity', 'Quantity (if applicable)', 'text', null, 'col-6', 'e.g. 24 shirts, 2 trucks'),
      mkField('budget', 'Budget range (optional)', 'select',
        ['Under $500', '$500 - $1,500', '$1,500 - $5,000', '$5,000 - $15,000', '$15,000+', 'Not sure yet'], 'col-6'),
      mkField('artwork_status', 'Do you have artwork?', 'select',
        ['Yes - print-ready files', 'Yes - but it needs cleanup', 'No - I need it designed'], 'col-6'),
      mkField('heard_about', 'How did you hear about us?', 'select',
        ['Google search', 'Facebook / Instagram', 'Saw a vehicle or sign', 'Referred by someone',
         'Repeat customer', 'Other'], 'col-6')
    ].forEach(function (f) { moreInner.appendChild(f); });

    var wideScreen = true;
    try { wideScreen = window.matchMedia('(min-width: 760px)').matches; } catch (e) {}

    function setMore(openState) {
      moreInner.hidden = !openState;
      toggle.setAttribute('aria-expanded', openState ? 'true' : 'false');
      toggle.textContent = (openState ? '- ' : '+ ') +
        'Optional: quantity, budget, artwork, how you found us';
    }
    toggle.addEventListener('click', function () {
      setMore(moreInner.hidden);
    });
    setMore(wideScreen);

    more.appendChild(toggle);
    more.appendChild(moreInner);
    detailsGrid.insertBefore(more, detailsWrap);
  }

  // ---- staff mode UI -----------------------------------------------------
  if (staffMode) {
    var banner = document.createElement('div');
    banner.className = 'vgc-staff-banner';
    banner.innerHTML = '<strong>Staff entry mode</strong> - logged as a staff entry, ' +
      'customer email optional, consent boxes skipped. ';
    var exit = document.createElement('button');
    exit.type = 'button';
    exit.className = 'vgc-staff-exit';
    exit.textContent = 'Exit staff mode';
    exit.addEventListener('click', function () { setStaff(false); });
    banner.appendChild(exit);
    form.insertBefore(banner, form.firstChild);

    if (infoGrid) {
      infoGrid.appendChild(mkField('entered_by', 'Entered by (staff name)', 'text', null, 'col-6', 'Who took this?'));
    }
    var checks = form.querySelector('.vgc-checks');
    if (checks) checks.hidden = true;
    var hb2 = form.querySelector('[name="heard_about"]');
    if (hb2 && hb2.closest('.vgc-field')) hb2.closest('.vgc-field').hidden = true;
    var emailEl = form.querySelector('[name="email"]');
    if (emailEl) {
      emailEl.removeAttribute('required');
      var el2 = emailEl.closest('.vgc-field');
      var lab2 = el2 ? el2.querySelector('label') : null;
      if (lab2) lab2.textContent = 'Email (optional for staff entries)';
    }
  }

    var chosen = [];

    var prog = document.createElement('div');
    prog.className = 'vgc-v2-progress';
    prog.hidden = true;
    prog.innerHTML = '<div class="vgc-v2-bar"><div class="vgc-v2-fill"></div></div>' +
      '<div class="vgc-v2-label" role="status" aria-live="polite"></div>';
    btn.parentNode.insertBefore(prog, btn.nextSibling);
    var fill = prog.querySelector('.vgc-v2-fill');
    var label = prog.querySelector('.vgc-v2-label');

    function showProgress(pct, text) {
      prog.hidden = false;
      fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      label.textContent = text || '';
    }

    function render() {
      if (!listEl) return;
      listEl.innerHTML = '';
      chosen.forEach(function (f, i) {
        var row = document.createElement('div');
        row.className = 'vgc-file-row';
        var left = document.createElement('div');
        left.className = 'vgc-file-row-left';
        var nm = document.createElement('div');
        nm.className = 'vgc-file-name';
        nm.textContent = f.name;
        var sz = document.createElement('div');
        sz.className = 'vgc-file-size';
        sz.textContent = mb(f.size) + ' MB';
        left.appendChild(nm); left.appendChild(sz);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'vgc-file-remove';
        x.setAttribute('aria-label', 'Remove file');
        x.textContent = '×';
        x.addEventListener('click', function () { chosen.splice(i, 1); render(); });
        row.appendChild(left); row.appendChild(x);
        listEl.appendChild(row);
      });
    }

    function checkFile(f) {
      if (ALLOWED.indexOf(extOf(f.name)) === -1) return 'File type not allowed: ' + f.name;
      if (f.size > MAX_BYTES_EACH) return f.name + ' is ' + mb(f.size) + 'MB. Max is 35MB per file.';
      return null;
    }

    input.addEventListener('change', function () {
      var incoming = Array.prototype.slice.call(input.files || []);
      for (var i = 0; i < incoming.length; i++) {
        var f = incoming[i];
        var dupe = chosen.some(function (c) { return c.name === f.name && c.size === f.size; });
        if (dupe) continue;
        var err = checkFile(f);
        if (err) { say(err); continue; }
        if (chosen.length >= MAX_FILES) { say('Max ' + MAX_FILES + ' files.'); break; }
        chosen.push(f);
        say('');
      }
      input.value = '';
      render();
    });

    function uploadOne(file, idx, total, onPct) {
      return new Promise(function (resolve, reject) {
        var fd = new FormData();
        fd.append('action', 'upload');
        fd.append('authKey', (form.querySelector('[name="authKey"]') || {}).value || '');
        fd.append('name', (form.querySelector('[name="name"]') || {}).value || '');
        fd.append('email', (form.querySelector('[name="email"]') || {}).value || '');
        fd.append('idx', String(idx));
        fd.append('total', String(total));
        fd.append('file', file, file.name);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.upload.onprogress = function (ev) {
          if (ev.lengthComputable) onPct(ev.loaded / ev.total);
        };
        xhr.onload = function () {
          var data = null;
          try { data = JSON.parse(xhr.responseText); } catch (e) {}
          if (xhr.status >= 200 && xhr.status < 300 && data && data.ok) resolve(data);
          else reject(new Error((data && data.error) || ('Upload failed for ' + file.name)));
        };
        xhr.onerror = function () { reject(new Error('Network error while uploading ' + file.name)); };
        xhr.send(fd);
      });
    }

    function submitLead(urls) {
      var fd = new FormData(form);
      fd.delete('files');
      fd.delete('file');
      fd.set('action', 'submit');
      fd.set('fileUrls', JSON.stringify(urls));
      return fetch(endpoint, { method: 'POST', body: fd })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          if (!d || !d.ok) throw new Error((d && d.error) || 'Submission failed. Please try again.');
          return d;
        });
    }

    function servicesPicked() {
      return Array.prototype.filter.call(
        form.querySelectorAll('input[name="service"]'), function (i) { return i.checked; }
      ).map(function (i) { return i.value; });
    }

    // If the backend is unreachable the visitor must not hit a dead end: their
    // answers stay on screen and we hand them a one-tap email containing
    // everything they typed, so the lead survives an outage.
    function offerRecovery() {
      if (form.querySelector('.vgc-recover')) return;

      var lines = [];
      function add(label, val) { if (val && String(val).trim()) lines.push(label + ': ' + val); }
      add('Name', (form.querySelector('[name="name"]') || {}).value);
      add('Company', (form.querySelector('[name="company"]') || {}).value);
      add('Email', (form.querySelector('[name="email"]') || {}).value);
      add('Phone', (form.querySelector('[name="phone"]') || {}).value);
      add('Project type', servicesPicked().join(', '));
      add('Timeline', (form.querySelector('[name="duedate"]') || {}).value);
      add('Quantity', (form.querySelector('[name="quantity"]') || {}).value);
      add('Budget', (form.querySelector('[name="budget"]') || {}).value);
      add('Artwork', (form.querySelector('[name="artwork_status"]') || {}).value);
      add('Details', (form.querySelector('[name="project_details"]') || {}).value);
      if (chosen.length) {
        add('Files', chosen.map(function (f) { return f.name; }).join(', ') +
          ' (please attach these to this email)');
      }

      var body = 'My quote request did not go through on the website. Here are my details:\n\n' +
        lines.join('\n');
      var href = 'mailto:info@valleygraphicscompany.com' +
        '?subject=' + encodeURIComponent('Quote request (website form failed)') +
        '&body=' + encodeURIComponent(body);

      var box = document.createElement('div');
      box.className = 'vgc-recover';
      box.setAttribute('role', 'alert');
      var p = document.createElement('p');
      p.textContent = 'Your details are still filled in above - nothing is lost. ' +
        'You can hit Submit again, or send them straight to us:';
      var a = document.createElement('a');
      a.className = 'vgc-recover-btn';
      a.href = href;
      a.textContent = 'Email my request instead';
      box.appendChild(p);
      box.appendChild(a);
      if (btn.parentNode) btn.parentNode.appendChild(box);
    }

    function succeed() {
      var panel = document.createElement('div');
      panel.className = 'vgc-v2-done';
      panel.setAttribute('role', 'status');
      panel.innerHTML = '<div class="vgc-v2-check" aria-hidden="true">&#10003;</div>' +
        '<h3>' + (staffMode ? 'Entry logged' : 'Quote request received') + '</h3>' +
        '<p>' + (staffMode
          ? 'Saved as a staff entry. Reload the page to log another.'
          : 'Thanks - we have your details and your files. We will follow up by email, usually within one business day.') +
        '</p>';
      form.parentNode.replaceChild(panel, form);
      try { panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}

      // Conversion tracking. GA4 and the Meta pixel are already loaded on this
      // page by the theme, so there is nothing extra to install.
      var picked = servicesPicked().join(', ');
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', {
            method: staffMode ? 'staff_entry' : 'quote_form',
            service_type: picked,
            currency: 'USD',
            value: 0
          });
        }
      } catch (e) {}
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', { content_name: 'Quote form', content_category: picked });
        }
      } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'vgc_quote_submitted', service_type: picked });
      } catch (e) {}

      document.dispatchEvent(new CustomEvent('vgc:quote-submitted', { detail: { services: picked } }));
    }

    function runFlow() {
      btn.disabled = true;
      btn.textContent = 'Submitting...';
      var total = chosen.length;
      var urls = [];
      var chain = Promise.resolve();

      chosen.forEach(function (file, i) {
        chain = chain.then(function () {
          return uploadOne(file, i + 1, total, function (frac) {
            showProgress(((i + frac) / total) * 90,
              'Uploading ' + (i + 1) + ' of ' + total + ' - ' + file.name +
              ' (' + Math.round(frac * 100) + '%)');
          }).then(function (res) { urls.push({ name: res.name, url: res.url }); });
        });
      });

      chain
        .then(function () {
          showProgress(total ? 95 : 60, 'Sending your request...');
          return submitLead(urls);
        })
        .then(function () { showProgress(100, 'Done'); succeed(); })
        .catch(function (err) {
          prog.hidden = true;
          say((err && err.message) || 'Something went wrong. Please try again.');
          btn.disabled = false;
          btn.textContent = 'Submit Quote Request';
          offerRecovery();
        });
    }

    // Staff mode bypasses the legacy validator, which hard-requires an email.
    // A capture listener on document runs before the form's own listeners.
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !staffMode) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      var nm = ((form.querySelector('[name="name"]') || {}).value || '').trim();
      var dt = ((form.querySelector('[name="project_details"]') || {}).value || '').trim();
      var any = Array.prototype.some.call(
        form.querySelectorAll('input[name="service"]'), function (i) { return i.checked; });
      if (!nm || !dt || !any) {
        say('Staff entry needs a name, at least one project type, and details.');
        return;
      }
      runFlow();
    }, true);

    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      runFlow();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
